import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  Button,
  TextField,
  FormHelperText,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../../utils/common';
import config from '../../../config';
import DropZone from '../../../components/DropZone';
import FormInputLabel from '../../../components/FormInputLabelView';

// const errMessage = {
//   required: 'required_field',
//   invalidField: 'this_field_is_invalid',
// };

export const dropZoneOption = {
  acceptFile: '.jpg,.png,.gif,.jpeg',
  maxSize: 10,
  limitationText: 'สามารถอัพโหลดไฟล์นามสกุล (jpg, png, gif) ครั้งละ 1 ไฟล์และขนาดไม่เกิน 10 MB',
};

class Map extends React.PureComponent {
  dropZoneMaps;

  constructor(props) {
    super(props);
    this.state = {
      isChangeData: false,
      isNext: false,
      isBack: false,
      data: {
        id: null,
        name: '',
        imgUrl: '',
        locationId: null,
        tenantId: null,
        tenantName: '',
        subgroupId: null,
        subgroupName: '',
        deletedImg: '',
      },
      dialogWarningForm: {
        id: null,
        name: null,
        open: false,
      },
      isUploadingMaps: false,
      errorField: {
        name: false,
        imgUrl: false,
      },
    };
  }

  async componentDidMount() {
    console.log('componentDidMount from Map');
    const { tenantId } = this.props.tenant.toJS();
    await this.initTenantData(tenantId);
    this.initData();
  }

  async initTenantData(tenantId) {
    const { data } = this.props.subGroup.toJS();
    const tenant = await this.props.tenant.getTenantsById(tenantId);
    this.setState({
      data: {
        tenantId: tenant.id,
        tenantName: tenant.name,
        locationId: tenant.locationId,
        subgroupId: data.moduleId,
        subgroupName: data.name,
      },
    });
  }

  async initData() {
    const { mapId } = this.props.maps.toJS();
    if (mapId) {
      const mapData = await this.props.maps._getMapById(mapId);
      if (mapData) {
        this.setState({
          data: {
            ...this.state.data,
            id: mapData.id,
            name: mapData.name,
            imgUrl: mapData.imgUrl,
            deletedImg: '',
          },
        });
      }
    }
  }

  handleNext = () => {
    this.setState({ isNext: true });

    const { t } = this.props;
    const { isChangeData } = this.state;
    if (isChangeData) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSave();
        } else {
          this.setState({ isNext: false });
        }
      });
    } else {
      // set next page
      this.handleSetStep('next');
    }
  };

  handleBack = () => {
    this.setState({ isBack: true });

    const { t } = this.props;
    const { isChangeData } = this.state;
    if (isChangeData) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSave();
        } else {
          this.setState({ isBack: false });
        }
      });
    } else {
      this.handleSetStep('back');
    }
  };

  handleUpdateMap = async () => {
    const { t } = this.props;
    const { data } = this.state;
    if (!data.id) {
      try {
        const result = await this.props.maps.createMap(data);
        if (result.statusCode === 200) {
          // assign in module
          const mapId = result.body.id;
          this.props.maps.setAction('mapId', mapId);
          await this.props.subGroup.assignMap(mapId, data.subgroupId);
          this.setState({ isChangeData: false });
          this.handleSetStep();
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else {
          const msg = e.error.message || `${t('failed_to_create')}`;
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        }
      }
    } else {
      try {
        await this.handleDelete(data.deletedImg);
        const result = await this.props.maps.updateMap(data);
        if (result.statusCode === 200) {
          this.setState({ isChangeData: false });
          this.handleSetStep();
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else {
          const msg = e.error.message || `${t('failed_to_update')}`;
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        }
      }
    }
  };

  handleSave = async () => {
    if (this.validate()) {
      if (this.dropZoneMaps && this.dropZoneMaps.state.files.length > 0) {
        if (this.dropZoneMaps.state.files[0].size > 1048576) {
          Swal.fire({
            type: 'error',
            text: `ไฟล์ที่อัพโหลดไม่ถูกต้อง รูปต้องมีขนาด ไม่เกิน 1 MB เท่านั้น`,
          });
        } else {
          await this.onUploadMaps();
        }
      } else {
        await this.handleUpdateMap();
      }
    }
  };

  handleResetData = () => {
    this.setState({
      data: {
        ...this.state.data,
        name: '',
      },
      isChangeData: false,
      isNext: false,
      isBack: false,
    });
    this.initData();
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
      isChangeData: true,
    });
  };

  validate() {
    const { data } = this.state;
    if (!data.name || (this.dropZoneMaps && this.dropZoneMaps.state.files.length === 0)) {
      let checkName = !data.name ? true : false;
      let checkImgUrl = !data.imgUrl ? true : false;
      this.setState({
        errorField: {
          name: checkName,
          imgUrl: checkImgUrl,
        },
      });
      return false;
    } else {
      this.setState({
        errorField: {
          name: false,
          imgUrl: false,
        },
      });
    }
    return true;
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: false,
        },
      });
    }
  }

  onUploadMaps = async () => {
    this.setState({ isUploadingMaps: true }, () => {
      this.dropZoneMaps.upload();
    });
  };

  onUploadMapsComplete = async (files) => {
    const url = files[0].res.url;
  
    // Update state with the new image URL and other flags
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        imgUrl: url,
      },
      isChangeData: true,
      isUploadingMaps: false,
    }));
  
    // Handle map update
    this.handleUpdateMap();
  };
  
  deleteFileOnClick = (imgUrl) => {
    this.setState({
      isChangeData: true,
      data: {
        ...this.state.data,
        imgUrl: null,
        deletedImg: imgUrl,
      },
    });
  };

  handleDelete = async (imgUrl) => {
    if (imgUrl) {
      const { t } = this.props;
      try {
        const result = await this.props.upload.deleteFile(imgUrl);
        if (result.statusCode === 200) {
          this.setState({
            data: {
              ...this.state.data,
              deletedImg: null,
            },
          });
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
        }
      }
    }
  };

  goToPage = (data) => {
    this.handleSetNavigation(data.wizardStep);
    this.props.wizard.setActiveStep(data.wizardStep);
  };

  handleSetNavigation = (step) => {
    const { navigations } = this.props.wizard.toJS();
    navigations.forEach((nav) => {
      if (nav.wizardPage === 'unit') {
        nav.wizardName = 'wizard_step_unit';
      }
    });
    const nav = navigations.filter((nav) => nav.wizardStep < step);
    this.props.wizard.setNavigation(nav);
  };

  handleSetStep = (task = null) => {
    const { data, isNext, isBack } = this.state;
    if (isNext || task === 'next') {
      this.setState({ isNext: false });

      const { navigations, activeStep } = this.props.wizard.toJS();
      const tmp = {
        wizardStep: activeStep,
        wizardPage: 'map',
        wizardName: data.name,
      };
      navigations.push(tmp);

      this.props.wizard.setNavigation(navigations);
      this.props.wizard.setRouterStep(true);
    }
    if (isBack || task === 'back') {
      this.setState({ isBack: false });

      const moduleStep = 3;
      this.props.wizard.setActiveStep(moduleStep);
      this.props.wizard.setActiveFlow('group');
      this.handleSetNavigation(moduleStep);
      this.props.wizard.setRouterStep(false);
    }
  };

  render() {
    const { classes, t } = this.props;
    const { data } = this.state;
    const { navigations } = this.props.wizard.toJS();

    return (
      <div>
        <Grid container>
          <Grid container item sm={12}>
            {(navigations || []).map((nav, i) => (
              <div id={nav.wizardPage} className={classes.nav} key={i} onClick={() => this.goToPage(nav)}>
                {' '}
                {t(`${nav.wizardName}`)}
                {' > '}
              </div>
            ))}
            <div className={classes.activeNav}>{t('wizard_map')}</div>
          </Grid>
          <Grid container item sm={12}>
            <div className={classes.textHeader}>{t('wizard_map_of')}</div>
            <div className={classes.textHeaderPrimary}>{navigations[3].wizardName}</div>
          </Grid>
        </Grid>

        <Grid container spacing={16} style={{ marginTop: 20 }}>
          <Grid item xs={12} sm={2}>
            <FormInputLabel label={t('tenant')} />
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              id='tenant'
              name='tenant'
              fullWidth
              value={data.tenantName || ''}
              onChange={this.handleChange}
              variant='outlined'
              margin='dense'
              className={classes.textField}
              InputProps={{
                className: classes.input,
              }}
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <FormInputLabel label={t('wizard_map_name')} required />
          </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              required
              id='name'
              name='name'
              fullWidth
              value={data.name || ''}
              onChange={this.handleChange}
              variant='outlined'
              margin='dense'
              className={classes.textField}
              InputProps={{
                className: classes.input,
              }}
              error={!data.reset ? this.state.errorField.name : false}
            />
            <FormHelperText error hidden={!data.reset ? !this.state.errorField.name : true} id='  component-error-text'>
              {t('required_field')}
            </FormHelperText>
          </Grid>

          <Grid item xs={12} sm={2}>
            <FormInputLabel label={t('wizard_map_picture')} required />
          </Grid>
          <Grid item xs={12} sm={10}>
            {data.imgUrl ? (
              <div className={`${classes.imgPreviewContainer} ${classes.spaceTop}`}>
                <div
                  id='delete'
                  className={classes.imgPreviewDel}
                  onClick={() => {
                    this.deleteFileOnClick(data.imgUrl);
                  }}
                >
                  <i className='fa fa-times-circle-o' aria-hidden='true' />
                </div>
                <div
                  className={classNames(classes.imgPreview, classes.rounded)}
                  style={{
                    background: `url("${data.imgUrl}") center no-repeat`,
                  }}
                />
              </div>
            ) : (
              <DropZone
                className={classes.dropzoneBox}
                ref={(e) => {
                  this.dropZoneMaps = e;
                }}
                placeholder={t('click_upload_photo')}
                url={`${config.api.url}/${config.api.version}/upload`}
                acceptedFiles={dropZoneOption.acceptFile}
                maxFileSize={dropZoneOption.maxSize}
                dirName='map'
                onAllComplete={this.onUploadMapsComplete}
                token={localStorage.getItem('id_token') || null}
              />
            )}

            <FormHelperText
              error
              hidden={!data.reset ? !this.state.errorField.imgUrl : true}
              id='  component-error-text'
            >
              {t('required_field')}
            </FormHelperText>
          </Grid>
        </Grid>

        <Grid container style={{ marginTop: 20, justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            <Button
              id='back'
              variant='outlined'
              color='primary'
              style={{ marginRight: 10 }}
              onClick={() => this.handleBack()}
              className={classes.btnPrimary}
            >
              {t('back')}
            </Button>
          </div>
          <div style={{ display: 'flex' }}>
            {this.state.isChangeData && (
              <Button
                id='reset'
                variant='outlined'
                color='primary'
                style={{ marginRight: 10 }}
                onClick={this.handleResetData}
                className={classes.btnPrimary}
              >
                {t('wizard_reset_data')}
              </Button>
            )}
            {this.state.isChangeData && (
              <Button
                id='save'
                variant='outlined'
                color='primary'
                style={{ marginRight: 10 }}
                className={classes.btnPrimary}
                onClick={this.handleSave}
              >
                {t('save')}
              </Button>
            )}
            <Button
              id='continue'
              variant='contained'
              color='primary'
              onClick={this.handleNext}
              className={classes.btnPrimary}
            >
              {t('wizard_continue')}
            </Button>
          </div>
        </Grid>
      </div>
    );
  }
}

const styles = (theme) => ({
  textHeader: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  textHeaderPrimary: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 30,
    marginLeft: 5,
  },
  btnPrimary: {
    width: 180,
    borderRadius: '4px',
  },
  textField: {
    fontWeight: 400,
    fontSize: 16,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
  imgPreviewContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  imgPreviewDel: {
    zIndex: 1,
    color: '#bf1e2e',
    position: 'absolute',
    right: 0,
    fontSize: '1.8rem',
    marginTop: '-21px',
    marginRight: '-11px',
    '&:hover, &:focus': {
      fontSize: '2.2rem',
      cursor: 'pointer',
    },
  },
  imgPreview: {
    position: 'relative',
    backgroundSize: 'contain !important',
    height: '350px',
    border: '1px solid #ced4da',
  },
  spaceTop: {
    marginTop: '10px',
  },
  dropzoneBox: {
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '350px',
  },
  nav: {
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    marginRight: 5,
  },
  activeNav: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
});

export const page = inject('wizard', 'tenant', 'subGroup', 'maps', 'upload')(observer(Map));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
